import { render, staticRenderFns } from "./BillExcelIframe.vue?vue&type=template&id=6c0f2d50&scoped=true"
import script from "./BillExcelIframe.vue?vue&type=script&lang=js"
export * from "./BillExcelIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f2d50",
  null
  
)

export default component.exports